export const ArtistTypeOptionList = [
  { id: "person", name: "person" },
  { id: "channel", name: "channel" },
  { id: "organization", name: "organization" }
];
